export interface UserDetails {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  company?: string;
  lastUpdated: number;
}

const STORAGE_KEY = "existing_user_details";

export function getUserDetails(): UserDetails | null {
  if (typeof window === "undefined") return null;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const details = JSON.parse(stored) as any;

    const cleanedDetails: UserDetails = {
      firstName: typeof details.firstName === "string" ? details.firstName : undefined,
      lastName: typeof details.lastName === "string" ? details.lastName : undefined,
      email: typeof details.email === "string" ? details.email : undefined,
      phone: typeof details.phone === "string" ? `${details.phone}` : undefined,
      company: typeof details.company === "string" ? details.company : undefined,
      lastUpdated: typeof details.lastUpdated === "number" ? details.lastUpdated : Date.now(),
    };

    return cleanedDetails;
  } catch (error) {
    console.error("Error reading user details from localStorage:", error);
    return null;
  }
}

